export function textValues(values: unknown): string[] {
  const list = Array.isArray(values) ? values : values == null ? [] : [values];
  return list
    .map((value) => {
      if (value == null) return "";
      if (typeof value === "string") return value;
      if (typeof value === "number" || typeof value === "boolean")
        return String(value);
      if (typeof value === "object") {
        const record = value as Record<string, unknown>;
        return String(
          record.prose ?? record.description ?? record.value ?? record.id ?? "",
        );
      }
      return String(value);
    })
    .filter(Boolean);
}

export function getParamId(param: Record<string, unknown>): string {
  return String(param.paramId ?? param.param_id ?? param["param-id"] ?? "");
}

export function getNestedParamSource(
  param: Record<string, unknown>,
  ...keys: string[]
): Record<string, unknown> | null {
  for (const key of keys) {
    const value = param[key];
    if (value && typeof value === "object" && !Array.isArray(value)) {
      return value as Record<string, unknown>;
    }
  }
  return null;
}

export function collectParamRecords(source: unknown): Record<string, unknown>[] {
  const records: Record<string, unknown>[] = [];
  const visited = new Set<unknown>();

  const walk = (value: unknown) => {
    if (!value || typeof value !== "object" || visited.has(value)) return;
    visited.add(value);

    if (Array.isArray(value)) {
      value.forEach(walk);
      return;
    }

    const record = value as Record<string, unknown>;
    if (getParamId(record)) records.push(record);
    Object.values(record).forEach(walk);
  };

  walk(source);
  return records;
}
